module.exports = __webpack_public_path__ + "static/media/arrow-left.c571ab21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-left.svg
// module id = 104
// module chunks = 0